/**
Author - Kaustubh Mishra
Git - https://github.com/KaustubhMishra25
**/

import React, {useState} from 'react';
import {PropTypes} from 'prop-types';

import UploadDocumentContainer from 'components/UploadDocument/UploadDocument.container';
import {uploadArnCard} from 'api';
import {handleApiError} from 'helpers';
import {sendEventsToNativeApp} from 'utils/ClientAppUtils';
import styled from 'styled-components';

const propTypes = {
  updateStatus: PropTypes.func.isRequired,
};

const ArnCardUpload = ({updateStatus}) => {
  const [isUploading, setIsUploading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const handleSubmitFile = async (formData) => {
    setErrorMessage('');
    setIsUploading(true);
    try {
      const res = await uploadArnCard(formData);
      if (res.status === 200) {
        sendEventsToNativeApp('ARN_UPLOADED');
        updateStatus();
      }
      if (res.status === 400) {
        res.json().then((data) => {
          setErrorMessage(data.detail);
        });
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <UploadDocWrapper>
      <UploadDocumentContainer
        isLoading={isUploading}
        onSubmitDocument={handleSubmitFile}
        heading="ARN Card Upload"
        subHeading="Please upload front copy of your ARN card."
        documentOptions={''}
        errorMessage={errorMessage}
        uploadMessage=""
      />
    </UploadDocWrapper>
  );
};

ArnCardUpload.prototype = propTypes;
export default ArnCardUpload;

const UploadDocWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  .upload-doc-content {
    padding: 0 !important;
  }

  .upload-doc-wrapper {
    height: 100%;
    flex-grow: 1;
  }

  .upload-doc-footer {
    margin-top: auto;
  }
`;
